import { createUseStyles } from "react-jss";

export default createUseStyles({
    checkBoxIcon: {
        composes: "check-box__icon",
        verticalAlign: "middle",
        fontSize: 23,
        pointerEvents: "none",

        "& .custom__Image": {
            "max-height": "100%",
        },
    },
    checkBoxIconChecked: {
        composes: "check-box__icon--checked",
    },
    checkBoxIconDisabled: {
        composes: "check-box__icon--disabled",
        opacity: 0.5,
    },
});
